export default __webpack_public_path__ + "static/media/tete46.9ce46112.png";